import { ApiError } from "../../shared/api/client";

export type SessionMode = "code" | "telegram";

export interface SessionState {
  authenticated: boolean;
  mode: SessionMode;
  user?: string | null;
}

export async function getSession(): Promise<SessionState> {
  try {
    const response = await fetch("/auth/session", { credentials: "same-origin" });
    if (!response.ok) return { authenticated: false, mode: "code" };
    const state = await response.json() as Partial<SessionState>;
    return {
      authenticated: state.authenticated === true,
      mode: state.mode === "telegram" ? "telegram" : "code",
      user: typeof state.user === "string" ? state.user : null,
    };
  } catch {
    return { authenticated: false, mode: "code" };
  }
}

// Telegram login is a navigation: the gateway starts the OIDC flow and comes
// back to the app with cookies set. Nothing about the login lives in the SPA.
export function telegramLoginURL(next = "/"): string {
  const params = new URLSearchParams({ next: next.startsWith("/") && !next.startsWith("//") ? next : "/" });
  return `/api/v1/auth/telegram/start?${params}`;
}

export async function unlock(code: string): Promise<void> {
  const response = await fetch("/auth/session", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "same-origin",
    body: JSON.stringify({ code }),
  });
  if (!response.ok) throw new ApiError(response.status, "That access code did not work.", null);
}

export async function lock(): Promise<void> {
  await fetch("/auth/session", { method: "DELETE", credentials: "same-origin" });
}
